import { CellWrap } from "@/components/board/cells/CellWrap";
import { DoneBox } from "@/components/ui/DoneBox";

interface CheckboxCellProps {
  value: boolean;
  rowH?: number;
  onChange?: (next: boolean) => void;
  // Table cells center the box in their column; the detail view wants it
  // left-aligned with every other field value. Defaults to "center" so the
  // table is unchanged.
  align?: "flex-start" | "center" | "right";
}

export function CheckboxCell({ value, rowH = 44, onChange, align = "center" }: CheckboxCellProps) {
  return (
    <CellWrap rowH={rowH} align={align} onClick={() => onChange?.(!value)}>
      <div role="checkbox" aria-checked={value} style={{ display: "flex" }}>
        <DoneBox checked={value} />
      </div>
    </CellWrap>
  );
}
